import { busService } from "../bus";
import { LoadingSpinnerMessage } from "../../messages/loading/LoadingSpinnerMessage";
/**
 * Shows or hides a simple Loading Spinner.
 * Activate it either by calling the function toggleLoadingSpinner directly or
 * by sending the LoadingSpinnerMessage.
 */
class LoadingSpinnerService {
    constructor() {
        this.reasonsToShowSpinner = 0;
        this.connection = busService.connection("LoadingSpinnerService");
        this.handleLoadingSpinnerMessage = (msg) => {
            loadingSpinnerService.toggleLoadingSpinner(msg.show);
        };
        this.connection.subscribeByType(LoadingSpinnerMessage, this.handleLoadingSpinnerMessage);
    }
    toggleLoadingSpinner(show) {
        if (show) {
            if (this.reasonsToShowSpinner === 0) {
                this.setVisible(true);
            }
            this.reasonsToShowSpinner += 1;
        }
        else {
            if (this.reasonsToShowSpinner === 1) {
                this.setVisible(false);
            }
            this.reasonsToShowSpinner -= 1;
        }
    }
    setVisible(show) {
        const progressElement = document.getElementById("progress-indicator");
        if (progressElement) {
            if (show)
                progressElement.classList.remove("progressbar-hidden");
            else
                progressElement.classList.add("progressbar-hidden");
        }
        const infoElement = document.getElementById("progress-indicator-parent");
        if (infoElement) {
            if (show)
                infoElement.classList.remove("progressbar-hidden");
            else
                infoElement.classList.add("progressbar-hidden");
        }
    }
}
export const loadingSpinnerService = new LoadingSpinnerService();
